import React from 'react';
import { Link } from 'react-router-dom';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';

const NotLoggedIn: React.FC = () => {
    return (
        <div style={{ marginTop: '10%' }}>
            <FontAwesomeIcon
                style={{ marginTop: "10px", color: "grey", fontSize: "10vw" }}
                icon={faExclamationTriangle}
            />
            <h1>È necessario effettuare il login per visualizzare questa pagina</h1>
            <Link to="/login">
                <Button variant="contained" color="primary">Effettua il login</Button>
            </Link>
        </div>
    );
};

export default NotLoggedIn;
